import classNames from "classnames";
import { existsBy, isNotEmpty } from "neetocist";
import { joinHyphenCase } from "neetocommons/utils/general";
import { Dropdown } from "neetoui";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

const { Menu, MenuItem } = Dropdown;

const OverflowLinks = ({ overflowLinks }) => {
  const { pathname } = useLocation();
  const { t } = useTranslation();

  const isMoreButtonActive = existsBy({ to: pathname }, overflowLinks);

  if (!isNotEmpty(overflowLinks)) {
    return null;
  }

  return (
    <Dropdown
      buttonStyle="text"
      label={t("neetoMolecules.navigationHeader.more")}
      position="bottom-end"
      buttonProps={{
        className: classNames(
          "neeto-molecules-navigation-header__link neeto-molecules-navigation-header__link--more neeto-ui-typography neeto-ui-text-h4 neeto-ui-font-semibold neeto-ui-leading-normal px-2 capitalize no-underline md:px-0",
          { active: isMoreButtonActive }
        ),
      }}
    >
      <Menu>
        {overflowLinks.map(({ key, to, label, disabled, ...rest }) => {
          const isActive = to === pathname;
          const menuButton = (
            <MenuItem.Button
              {...{ isActive, to }}
              data-testid={`${joinHyphenCase(key)}-more-tab`}
              isDisabled={disabled}
              key={key}
              onClick={e => disabled && e.preventDefault()}
              {...rest}
            >
              {label}
            </MenuItem.Button>
          );

          if (
            isActive &&
            rest.moreOptions &&
            isNotEmpty(rest.moreOptions.menuItems)
          ) {
            return (
              <Dropdown
                customTarget={menuButton}
                key={`${key}-nested-dropdown`}
                position="right-start"
                trigger="hover"
              >
                <Menu>
                  {rest.moreOptions.menuItems.map(
                    ({ key, label, ...itemProps }) => (
                      <MenuItem.Button key={key} {...itemProps}>
                        {label}
                      </MenuItem.Button>
                    )
                  )}
                </Menu>
              </Dropdown>
            );
          }

          return menuButton;
        })}
      </Menu>
    </Dropdown>
  );
};

OverflowLinks.propTypes = {
  /**
   * Array of overflow links to be displayed in the more dropdown
   */
  overflowLinks: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      to: PropTypes.string,
      label: PropTypes.string,
      disabled: PropTypes.bool,
      moreOptions: PropTypes.shape({
        menuItems: PropTypes.arrayOf(
          PropTypes.shape({
            key: PropTypes.string,
            label: PropTypes.string,
            onClick: PropTypes.func,
            disabled: PropTypes.bool,
            isDisabled: PropTypes.bool,
            tooltipProps: PropTypes.shape({
              content: PropTypes.string,
            }),
          })
        ),
      }),
    })
  ),
};

export default OverflowLinks;
